import Create from '../../../base/forms/user/Create';

const create: Create = {
  header: 'Přidat uživatele',
  submit: 'Přidat',
};

export default create;
